module.exports = "https://la-static.vkplay.ru/promo/newstart/img/location-5.0251b196.jpg";